import { useTranslation } from "react-i18next";

export const useHeaderTranslate = () => {
  const { t } = useTranslation();

  return {
    moreNavItems: t("global_header_moreNavItems_label", {
      defaultValue: "More navigation items",
    }),
  };
};
